import {UsePermissions} from "../../../hooks/usePermissions";
import React, {useEffect, useRef, useState} from "react";

import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {eliminarPensionado, getData, guardarData} from "../../../api/pensionado.service";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Dropdown} from "primereact/dropdown";
import {confirmDialog} from "primereact/confirmdialog";
import {UseLoader} from "../../../hooks/useLoader";

export const TablaPensionado= ({obtenerParametrosUser, nuevoUsuario, reload}) => {
    const [permisos] = UsePermissions()
    // parametros de la tabla
    const [handleLoader] = UseLoader();
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowInit, setrowInit] = useState(50);
    const [compensacion, setCompensacion] = useState([]);
    const toast = useRef(null);


    const initParams= {
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            'nombre': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'porcentaje': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'estado': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]}
        }
    }

    const [lazyParams, setLazyParams] = useState(initParams);

    async function init(datos) {
        const response = await getData(datos);
        const data = await response.data;
        return data.data;
    }

    const loadLazyData = () => {
        setLoading(true);
        init({lazyEvent: lazyParams}).then(data => {
            // record
            setTotalRecords(data.total);
            // total
            setCompensacion(data.record);
            setLoading(false);
        })
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onPage = (event) => {
        setrowInit(event.rows);
        setLazyParams(event);
    }

    const laziParamsInit = () => {
        setLazyParams(initParams);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    useEffect(() => {
        loadLazyData();

        return () => {
            // record
            setTotalRecords(0);
            setCompensacion([]);

        }
    }, [lazyParams])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (reload) {
            loadLazyData();
        }
        return () => {

        }
    }, [reload]);

    const status = [
        {
            name: "Activo",
            value: "A"
        },
        {
            name: "Inactivo",
            value: "I"
        }
    ];

    const deletePen = (rowData) => {
       confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () =>  {
                handleLoader(true);
                const response= await eliminarPensionado(rowData.pensionado_id);
                const data= await response.data;

                handleLoader(false);
                if (data.estado !== 200) {
                    toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                    return;
                }

                toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                reload();
            }
        });
    }

    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option.value}`}>{option.name}</span>;
    }

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={status}
                         onChange={(e) => options.filterCallback(e.value, options.index)}
                         optionLabel="name"
                         itemTemplate={statusItemTemplate}
                         placeholder="Seleccione un estado" className="p-column-filter"
                         showClear/>;
    }

    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevoUsuario}
                >
                    <i className="fa fa-user"/>
                </button>
            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={loadLazyData}
                >
                    <i className="fa fa-search"/>
                </button>

                <button
                    onClick={laziParamsInit}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-filter"/>
                </button>

            </div>

        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">
                <button
                    disabled={!permisos.editar}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametrosUser(rowData)}>
                    <i className="fa fa-user-edit"/>
                </button>

                <button
                    disabled={!permisos.eliminar}
                    className="btn danger-color-btn "
                    type="button"
                    onClick={() => deletePen(rowData)}>
                    <i className="fa fa-trash"/>
                </button>
            </div>
        );
    }

    return(
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <ContainerTable>
                <DataTable
                    showGridlines
                    header={header}
                    resizableColumns
                    columnResizeMode="expand"
                    size="small"
                    value={compensacion}
                    lazy
                    filterDisplay="menu"
                    first={lazyParams.first}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    onSort={onSort}
                    sortField={lazyParams.sortField}
                    sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter}
                    filters={lazyParams.filters}
                    loading={loading}
                    paginator
                    rows={rowInit}
                    scrollable scrollHeight="500px"
                    rowsPerPageOptions={[50, 100, 300, 500]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} pensionados"
                    responsiveLayout="scroll"
                >
                    <Column header="Acción"
                            style={{fontSize: ".8em"}}
                            body={actionTemplate}>
                    </Column>

                    <Column field="nombre"
                            header="Nombre"
                            sortable filter
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}
                    >
                    </Column>
                    <Column field="porcentaje"
                            header="Porcentaje"
                            sortable filter
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}
                    >
                    </Column>
                    <Column field="estado"
                            header="Estado"
                            sortable filter
                            filterElement={statusFilterTemplate}
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}
                    >
                    </Column>
                </DataTable>
            </ContainerTable>

        </>
    )
}
